export default __webpack_public_path__ + "static/img3-cf0c9fb86bca013559651be20d90a0ce.jpg";